var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-flex-c"},[(_vm.title)?_c('div',{staticClass:"row-title mt-2"},[_c('span',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{class:[
      'd-flex d-flex-r d-flex-between align-center content-row',
      { 'no-divider': _vm.hideDivider },
    ]},[_c('div',{staticClass:"d-flex left"},[_vm._t("content-left")],2),_c('div',{staticClass:"d-flex right"},[_vm._t("content-right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }